import type { FC } from 'react';

export const BellIcon: FC<{ color?: string }> = ({ color = '#E6E6E9' }) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 10V7a4 4 0 118 0v3l1 2H3l1-2z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 12a2 2 0 004 0" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
